import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { Modal, Paragraph } from "buoy-core"
import { sendVisitData, cancelIntellivisit } from "../actions"

const ModalParagraph = styled(Paragraph)`
  line-height: 1.25;
`

const modalLegalText = [
  "You are now leaving the Buoy site. You will be redirected to Intellivisit, RCW's virtual care platform.",
  `By clicking "Agree & Continue" you permit Buoy to share the data you just provided with Intellivisit. Intellivisit will use these data to connect you to an RCW medical provider who can evaluate your medical concerns with your consent.`,
]

const TelemedicineModal = ({ show, onSubmit, onCancel }) =>
  show ? (
    <Modal
      message={modalLegalText[0]}
      showSubmit={true}
      submitText="Agree & Continue"
      submitClick={onSubmit}
      showCancel={true}
      cancelText="Cancel"
      cancelClick={onCancel}
    >
      <ModalParagraph>{modalLegalText[1]}</ModalParagraph>
    </Modal>
  ) : null

const mapStateToProps = state => ({
  show: state.payment.showTelemedicineModal,
})

const mapDispatchToProps = dispatch => ({
  onSubmit: () => dispatch(sendVisitData()),
  onCancel: () => dispatch(cancelIntellivisit()),
})

const ConnectedTelemedicineModal = connect(mapStateToProps, mapDispatchToProps)(
  TelemedicineModal
)

export { ConnectedTelemedicineModal as default }



// WEBPACK FOOTER //
// ./assets/payment/components/TelemedicineModal.js